import script from "./HrPageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPageContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer});
